import { S } from '../components/styles';

const fmtDateShort = d => new Date(d).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'});
function avgRating(dish) {
  const rs = dish.dish_ratings || [];
  return rs.length ? rs.reduce((a,r)=>a+r.rating,0)/rs.length : 0;
}

export default function HistoryView({ events, onNavigate }) {
  const past = events.filter(e => e.status === 'past').sort((a,b)=>new Date(b.date)-new Date(a.date));
  return (
    <div>
      <div style={S.pageHero}><h2 style={S.h2}>Party History</h2><p style={S.textMuted}>A chronicle of memorable gatherings and beloved dishes</p></div>
      <div style={S.content}>
        {past.length===0 && <div style={S.empty}><div style={{fontSize:52,marginBottom:16}}>📚</div><h3 style={{fontFamily:'Cormorant Garamond,serif',fontSize:24,marginBottom:8}}>No history yet</h3><p style={{color:'#7A6555',fontSize:14}}>Past dinner parties and their recipes will be archived here.</p></div>}
        {past.map(ev => {
          const approved = (ev.dishes||[]).filter(d=>d.status==='approved');
          const sorted = [...approved].sort((a,b)=>avgRating(b)-avgRating(a));
          const fav = sorted[0];
          return (
            <div key={ev.id} style={{position:'relative',paddingLeft:26,paddingBottom:28}}>
              <div style={{position:'absolute',left:0,top:4,width:15,height:15,borderRadius:'50%',background:'#C4612A',border:'3px solid #FAF7F2',boxShadow:'0 0 0 1px #E5D9C8'}}/>
              <div style={{position:'absolute',left:7,top:6,bottom:0,width:1,background:'#E5D9C8'}}/>
              <p style={{fontSize:11,color:'#7A6555',textTransform:'uppercase',letterSpacing:'.07em',marginBottom:6}}>{fmtDateShort(ev.date)}</p>
              <div style={{...S.card,...S.cardPad,cursor:'pointer'}} onClick={()=>onNavigate('event',ev.id)}
                onMouseEnter={e=>{e.currentTarget.style.boxShadow='0 4px 20px rgba(44,26,14,.1)';}}
                onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';}}>
                <div style={{display:'flex',gap:12,marginBottom:14}}>
                  <span style={{fontSize:36}}>{ev.emoji}</span>
                  <div style={{flex:1}}>
                    <h4 style={{fontFamily:'Cormorant Garamond,serif',fontSize:20}}>{ev.title}</h4>
                    <p style={{fontSize:13,color:'#7A6555'}}>Hosted by {ev.profiles?.full_name} · {(ev.event_guests||[]).length+1} guests</p>
                  </div>
                  {fav && (
                    <div style={{textAlign:'right',flexShrink:0}}>
                      <p style={{fontSize:11,color:'#7A6555'}}>Crowd favourite</p>
                      <p style={{fontSize:13,fontWeight:500}}>{fav.name}</p>
                      <p style={{fontSize:11,color:'#7A6555'}}>{avgRating(fav).toFixed(1)} ★</p>
                    </div>
                  )}
                </div>
                <div style={S.divider}/>
                <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                  {approved.map(d=>(
                    <span key={d.id} style={{display:'inline-block',padding:'4px 10px',borderRadius:20,fontSize:11,fontWeight:500,background:'#FAEEE8',color:'#7B2D0D'}}>
                      {d.name}{avgRating(d)>0?` · ${avgRating(d).toFixed(1)}★`:''}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
